import { __exports as n } from "../../../../../../../_virtual/index.js";
import "./html/sanitizer.js";
import "./url/sanitizer.js";
import { __exports as a } from "../../../../../../../_virtual/sanitizer.js";
import { __exports as o } from "../../../../../../../_virtual/sanitizer2.js";
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "sanitizeHtml", {
    enumerable: !0,
    get: function() {
      return t.sanitizeHtml;
    }
  }), Object.defineProperty(e, "sanitizeUrl", {
    enumerable: !0,
    get: function() {
      return r.sanitizeUrl;
    }
  });
  var t = a, r = o;
})(n);
